module.exports = __webpack_public_path__ + "static/media/orange-nsc.5edf1241.png";